module.exports = __webpack_public_path__ + "assets/img/title_currency_bg.e1e865fe.png";